import { jsx } from 'react/jsx-runtime';
import { CodeSnippetControlsCopy } from './CodeSnippet.Controls.Copy/CodeSnippet.Controls.Copy.es.js';

const CodeSnippetControls = ({ children })=>jsx("div", {
        className: "cb-code-snippet-controls",
        children: children
    });
CodeSnippetControls.displayName = 'CodeSnippet.Controls';
CodeSnippetControls.Copy = CodeSnippetControlsCopy;

export { CodeSnippetControls };
//# sourceMappingURL=CodeSnippet.Controls.es.js.map
